export default __webpack_public_path__ + "static/media/cross.21148290.svg";